import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  otherSiteColor,
  clubSiteColor,
  clubSiteType,
  forestSiteColor,
  forestSiteType,
  certificatedSiteColor,
  certificatedSiteType,
  europeanSiteColor,
  europeanSiteType,
  listedSiteColor,
  listedSiteType,
  readyCampType,
  readyCampColor,
} from '../../constants/campsite-type';
import ModalMap from '../react/ModalMap';

export default class MapLocation {
  constructor(context) {
    this.context = context;
    this.root = createRoot(this.context.querySelector('.Map_inner'));
    this.init();
  }

  init() {
    const model = this.context.dataset;
    if (!model) throw Error('Missing a required dataset');

    const campsiteType = model.type;
    const pinColor = this.getPinColor(campsiteType);
    const showFullScreenButton = model.basicDevice.toLowerCase() === 'false';

    const results = [
      {
        latitude: parseFloat(model.latitude),
        longitude: parseFloat(model.longitude),
        index: 0,
        selected: true,
        iconSVGString: `data:image/svg+xml;charset=UTF-8;base64,${btoa(`<?xml version="1.0" encoding="UTF-8"?>
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve">
          <path class="st0" style="opacity:0.3;" d="M30,56.1c4.2,0,7.5-0.9,7.5-2s-3.4-2-7.5-2s-7.5,0.9-7.5,2S25.9,56.1,30,56.1z"/>
          <path class="st1" fill="#FFFFFF" d="M30.4,3.1c-9.7,0-17.6,7.9-17.6,17.6c0,7.1,4.2,13.4,10.8,16.1l4.8,11.8h3.9l4.8-11.8C43.6,34,48,27.6,48,20.6
            C48,11,40.2,3.1,30.4,3.1z"/>
          <path class="st1" fill="${pinColor}" d="M30.4,4.1c-9.1,0-16.5,7.4-16.5,16.5c0,6.8,4.1,12.8,10.5,15.4l4.7,11.5h2.5L36.2,36
            c6.4-2.5,10.7-8.6,10.7-15.4C46.9,11.5,39.5,4.1,30.4,4.1z M30.3,27.9c-4.1,0-7.5-3.3-7.5-7.5c0-4.1,3.4-7.6,7.5-7.6
            s7.5,3.3,7.5,7.5S34.5,27.9,30.3,27.9z"/>
        </svg>`)}`,
      },
    ];

    const defaultZoom = parseInt(model.zoom, 10);

    const options = {
      fullscreenControl: true,
    };

    this.root.render(
      <ModalMap
        model={model}
        results={results}
        defaultZoom={defaultZoom}
        options={options}
        showFullScreenButton={showFullScreenButton}
      />
    );
  }

  getPinColor = (campsiteType) => {
    switch (campsiteType) {
      case clubSiteType:
        return clubSiteColor;
      case certificatedSiteType:
        return certificatedSiteColor;
      case europeanSiteType:
        return europeanSiteColor;
      case listedSiteType:
        return listedSiteColor;
      case forestSiteType:
        return forestSiteColor;
      case readyCampType:
        return readyCampColor;
      default:
        return otherSiteColor;
    }
  };
}
